import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ParcelInTrip } from '../apply-transit-dialog/apply-transit-dialog.component';
import { ParcelsInTripDialogComponent } from '../parcels-in-trip-dialog/parcels-in-trip-dialog.component';

export interface RemoveFromTripDialogData {
    message: string;
    tripGroups: string[];
    outcomes: string[];
    parcelsInTrip: ParcelInTrip[];
}

@Component({
    selector: 'app-remove-from-trip-dialog',
    standalone: true,
    templateUrl: './remove-from-trip-dialog.component.html',
    styleUrls: ['../select-new-tour-dialog/select-new-tour-dialog.component.css', '../apply-transit-dialog/apply-transit-dialog.component.css'],
    imports: [
        CommonModule,
        MatDialogModule
    ]
})
export class RemoveFromTripDialogComponent {
    constructor(
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<RemoveFromTripDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RemoveFromTripDialogData
    ) {
    }

    openParcelsInTripDialog(): void {
        this.dialog.open(ParcelsInTripDialogComponent, {
            width: '760px',
            maxWidth: '95vw',
            panelClass: 'app-popup-dialog',
            autoFocus: false,
            data: { parcelsInTrip: this.data.parcelsInTrip }
        });
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    confirm(): void {
        this.dialogRef.close(true);
    }
}
